import React from 'react';
import GenericModal from '../../components/agv-generic-modal';

/**
 * Confirmation de « Renvoyer en affectation camion » (suppression d'une
 * tournée non démarrée) : explique ce qui arrive à la tournée et à ses
 * commandes selon le mode d'envoi en exploitation.
 */
export default function DeleteTourModal({
  tour,
  isDispatchEnabled,
  isLoading,
  onClose,
  onConfirm,
}) {
  return (
    <GenericModal
      isOpen={Boolean(tour)}
      setIsOpen={(open) => {
        if (!open && !isLoading) onClose();
      }}
      title={`Renvoyer la tournée ${tour?.tour_key || ''} en affectation camion`}
      mainAction={onConfirm}
      mainActionText={'Renvoyer en affectation camion'}
      mainActionIsLoading={isLoading}
      secondaryAction={onClose}
      secondaryActionText={'Annuler'}
    >
      <div className="tw-flex tw-flex-col tw-pb-2 tw-gap-3 tw-text-sm">
        {isDispatchEnabled ? (
          <p className="tw-m-0">
            La tournée est retirée de l’exploitation : elle disparaît de cette
            liste et de l’application du chauffeur (le chauffeur affecté est
            retiré). Elle redevient un brouillon dans « Affectations camion »,
            avec ses commandes toujours sur le camion, qui peut de nouveau être
            modifié puis renvoyé en exploitation.
          </p>
        ) : (
          <p className="tw-m-0">
            La tournée et ses étapes sont supprimées. Ses commandes redeviennent
            « À placer » à la même date dans « Affectations camion ».
          </p>
        )}
        <p className="tw-m-0 tw-text-text-dark-medium-importance">
          Seule une tournée non démarrée (checklist non faite, aucune étape
          commencée) préparée dans « Affectations camion » peut y être renvoyée.
        </p>
      </div>
    </GenericModal>
  );
}
